"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var LocationIcon_1 = __importDefault(require("../../Icons/LocationIcon"));
var SearchIcon = function (_a) {
    var value = _a.value;
    return (react_1.default.createElement(react_1.default.Fragment, null, value ? (react_1.default.createElement("span", { className: "search-icon-cont" },
        react_1.default.createElement("i", { className: "cm-icon icon-search" }))) : (react_1.default.createElement("span", { className: "search-location-icon" },
        react_1.default.createElement(LocationIcon_1.default, null)))));
};
exports.default = react_1.memo(SearchIcon);
